/**
 * Custom theme JS
 */

document.addEventListener('DOMContentLoaded', function () {
  let hidden = false;

  // -----------------------------
  // Logo hide on scroll
  // -----------------------------
  function handleScroll() {
    const y = window.pageYOffset || document.documentElement.scrollTop;

    if (y > 250 && !hidden) {
      document.body.classList.add('logo-hidden');
      hidden = true;
    } else if (y < 220 && hidden) {
      document.body.classList.remove('logo-hidden');
      hidden = false;
    }
  }

  window.addEventListener('scroll', handleScroll);
  handleScroll();

  // -----------------------------
  // Search open
  // -----------------------------
  document.querySelectorAll('.searchBtn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const headerSearch = document.querySelector('.header-search');
      const searchInput = document.querySelector('form#search input.form-control');

      if (headerSearch) {
        headerSearch.classList.add('active');
      }

      if (searchInput) {
        searchInput.focus();
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  });

  // -----------------------------
  // Search close
  // Supports both spellings just in case
  // -----------------------------
  document.querySelectorAll('.search-close, .serach-close').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const headerSearch = document.querySelector('.header-search');

      if (headerSearch) {
        headerSearch.classList.remove('active');
      }
    });
  });

  // -----------------------------
  // Slick sliders
  // Only runs if jQuery + Slick are loaded
  // -----------------------------
  if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
    const $ = window.jQuery;

    if ($('.artisan-slider').length) {
      $('.artisan-slider').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    if ($('.bespoke-slider').length) {
      $('.bespoke-slider').slick({
        dots: true,
        infinite: true,
        speed: 1000,
        autoplay: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: false,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              adaptiveHeight: true
            }
          }
        ]
      });
    }
  } else {
    console.warn('jQuery and/or Slick not loaded. Slider code was skipped.');
  }
});